<template>
  <div>
    <commande-card :commande="commande" class="mgb-20px"/>
    <store-recherche-provider
      :key="'lignesCommandeAchat'"
      :name="constantes.storeName"
      :copy="storeCopy"
      :isTemporary="true">
      <liste-lignes-commande-achat
        :nameStore="constantes.storeName"
      />
    </store-recherche-provider>
  </div>
</template>

<script>
import CommandeCard from '@/components/commande/logistiqueImpression/stepImpression/commandeCard';
import StoreRechercheProvider from '@/components/general/store/storeRechercheProvider';
import listeLignesCommandeAchat from '@/components/commande/detail/ligneCommandeAchat/listeLignesCommandeAchat';
import ligneCommande from '@/store/modules/ligneCommande';

export default {
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      storeCopy: ligneCommande,
      constantes: {
        storeName: 'lignesCommandeAchatDansCommandeVente',
      },
    };
  },
  components: {
    CommandeCard,
    StoreRechercheProvider,
    listeLignesCommandeAchat,
  },
};
</script>

<style>

</style>
